import axios from 'axios'
import API from './API.js'

export default class Polls extends API {
  constructor() {
    super('polls')
  }

  async HomePolls() {
    try {
      const response = await axios.get('polls/home')
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  //getPoll/2
  async GetPoll(id) {
    try {
      const response = await axios.get(`getPoll/${id}`)
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }

  async SetPoll(data) {
    //{answerids, pollId}
    try {
      const response = await axios.post(`setPoll`, data)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }

  }
}
